import { render, staticRenderFns } from "./ToTopBtn.vue?vue&type=template&id=9373bea4&"
import script from "./ToTopBtn.vue?vue&type=script&lang=js&"
export * from "./ToTopBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports